export default __webpack_public_path__ + "static/Guido_de_Nobel_3-71be192b222433846a59720bef411cc9.jpg";